module.exports = __webpack_public_path__ + "static/sprite-09fdbac6f78a723c36f0907133e0ede6.svg";